"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHierarchicalLocations = getHierarchicalLocations;
const axios_1 = require("./clients/axios");
async function getHierarchicalLocations() {
    const response = await axios_1.client.get(`/0/location/hierarchy`);
    return response.data;
}
